// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"679":"182d425f","975":"5fb1d6e1"}[chunkId] + ".chunk.js");